// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3UGLU","validationTips":"StatementDescriptor_validationTips__1S4Fy"};